import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, fontFamily: "Helvetica", color: "#101828" },
  heading: { textAlign: "center", fontSize: 18, fontWeight: "bold", marginBottom: 20, color: "#003149" },
  recordGroup: { marginBottom: 12, paddingBottom: 8, borderBottomWidth: 1, borderBottomColor: "#ccc", borderBottomStyle: "solid" },
  row: { flexDirection: "row", justifyContent: "space-between", marginBottom: 6 },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportMonthlySummaryPDF = ({ data, logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {logo && (
          <Image
            src={logo}
            style={{ width: 140, alignSelf: "center", marginBottom: 10 }}
          />
        )}

        <Text style={styles.heading}>  {t("monthlySummary.title")}</Text>

        {data.map((item, idx) => (
          <View key={idx} style={styles.recordGroup}>

            <View style={styles.row}>
              <Text style={styles.label}>{t("monthlySummary.columns.id")}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("monthlySummary.columns.date")}:</Text>
              <Text style={styles.value}>{item.date}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("monthlySummary.columns.checkIn")}:</Text>
              <Text style={styles.value}>{item.checkIn}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("monthlySummary.columns.checkOut")}:</Text>
              <Text style={styles.value}>{item.checkOut}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("monthlySummary.columns.location")}:</Text>
              <Text style={styles.value}>{item.location}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("monthlySummary.columns.issues")}:</Text>
              <Text style={styles.value}>{item.issuesCount ?? 0}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("monthlySummary.columns.status")}:</Text>
              <Text style={styles.value}>{item.status}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportMonthlySummaryPDF;
